import Icon from "@client/controls/Icon/component";
import { withIsVisible } from "@client/hocs";
import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type MapProps = WithIsVisibleHOCProps & {
  caption: string;
};

export type ActionProps = {
  onApply: () => void;
};

export default withIsVisible((props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <div className="apply">
      <span dangerouslySetInnerHTML={{ __html: props.caption }} />
      <a onClick={props.onApply}>
        <Icon iconClassName="far fa-check-circle" /> {i18n.applyNow}
      </a>
    </div>
  );
});
